import {
  Box,
  Flex,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
} from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../../i18n';
import TooltipCircle from '../../../../../../../common/src/components/TooltipCircle';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import FlowsQuestionText from '../../../advisory-flow/components/FlowsQuestionText';

interface Props {
  question: FlowsQuestion;
}

const QuestionGroupQuestionTitle: React.FC<Props> = ({ question }) => {
  return (
    <Flex mb="2">
      <FlowsQuestionText question={question} />
      {question.description && (
        <Box ml="2">
          <Popover trigger="hover" placement="auto">
            <PopoverTrigger>
              <TooltipCircle size="sm">?</TooltipCircle>
            </PopoverTrigger>
            <PopoverContent
              bg="gray.700"
              color="white"
              textStyle="smallBodyMedium"
              lineHeight="5"
              sx={{ ul: { listStyle: 'disc', marginLeft: 4 }, li: { py: 1 } }}
            >
              <PopoverArrow bg="gray.700" color="white" />
              <PopoverBody
                dangerouslySetInnerHTML={{
                  __html: handleResponseLanguage(question.description),
                }}
              />
            </PopoverContent>
          </Popover>
        </Box>
      )}
    </Flex>
  );
};

export default QuestionGroupQuestionTitle;
